import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/ServicePage.css';
import { setPageMeta } from '../utils/seo';

const RPO = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    setPageMeta(
      'Recruitment Process Outsourcing (RPO) | HRCONSOL',
      'End-to-end RPO: dedicated teams, AI screening, analytics, and scalable hiring. Reduce time-to-hire by 40% and cost-per-hire by up to 50%.'
    );
  }, []);

  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <h1>Recruitment Process Outsourcing (RPO) – Powering Scalable Hiring Solutions</h1>
          <p className="subtitle">At HRCONSOL, we redefine recruitment through our end-to-end RPO solutions, enabling organizations to scale faster, hire smarter, and optimize talent acquisition costs.</p>
        </div>
      </div>

      <div className="container">
        <div className="service-content">
          <div className="service-section">
            <p>Our Recruitment Process Outsourcing model is designed for companies seeking efficiency, flexibility, and measurable hiring success across multiple sectors.</p>
          </div>

          <div className="service-section">
            <h2>Why Choose HRCONSOL RPO?</h2>
            <ul className="benefits-list">
              <li><i className="fas fa-check-circle"></i> Proven success with thousands of positions closed and 95% client satisfaction rate</li>
              <li><i className="fas fa-users-cog"></i> Dedicated recruitment teams integrated into your HR operations</li>
              <li><i className="fas fa-laptop-code"></i> Tech-driven sourcing and assessment tools ensuring faster, better-quality hires</li>
              <li><i className="fas fa-chart-line"></i> Transparent data-driven reporting & analytics for every stage of recruitment</li>
              <li><i className="fas fa-expand-arrows-alt"></i> Scalable hiring solutions—from project-based hiring to enterprise-level RPO</li>
              <li><i className="fas fa-piggy-bank"></i> Significant cost savings vs. traditional hiring models</li>
              <li><i className="fas fa-plug"></i> Seamless integration with your HRMS and ATS systems</li>
            </ul>
          </div>

          <div className="service-section">
            <h2>Scope of RPO Services</h2>
            <div className="process-steps">
              <div className="step">
                <h3><i className="fas fa-users"></i> End-to-End Recruitment</h3>
                <p>From job posting to onboarding management.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-search"></i> Talent Mapping & Intelligence</h3>
                <p>Market intelligence and talent pipeline building.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-bullhorn"></i> Employer Branding</h3>
                <p>Candidate experience management and company branding.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-user-clock"></i> On-Demand Recruiters</h3>
                <p>Dedicated recruiter deployment as needed.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-chart-bar"></i> Recruitment Analytics</h3>
                <p>Continuous improvement and data tracking.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-robot"></i> AI-Powered Screening</h3>
                <p>Automated resume screening and filtering.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-user-tie"></i> Account Manager</h3>
                <p>Dedicated point of contact for your organization.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-handshake"></i> Interview Coordination</h3>
                <p>Complete interview scheduling and support.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-headset"></i> 24/7 Recruitment Desk</h3>
                <p>For high-volume hiring requirements.</p>
              </div>
            </div>
          </div>

          <div className="service-section">
            <h2>RPO Models We Offer</h2>
            <div className="process-steps">
              <div className="step">
                <h3><i className="fas fa-building"></i> Full RPO</h3>
                <p>We manage your entire recruitment function across all departments and levels.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-puzzle-piece"></i> Partial RPO</h3>
                <p>We handle specific hiring needs such as tech, sales, or executive recruitment.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-rocket"></i> Project RPO</h3>
                <p>Short-term recruitment support for expansion, seasonal hiring, or special projects.</p>
              </div>
              <div className="step">
                <h3><i className="fas fa-laptop"></i> On-Demand RPO</h3>
                <p>Flexible recruitment support as and when you need it.</p>
              </div>
            </div>
          </div>

          <div className="service-section">
            <h2>Sectors We Serve</h2>
            <p style={{ textAlign: 'center', fontSize: '1.1rem', marginBottom: '2rem' }}>We deliver RPO solutions across diverse industries, including:</p>
            <ul className="benefits-list" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))' }}>
              <li style={{ fontSize: '0.95rem', padding: '0.75rem' }}><i className="fas fa-laptop-code"></i> Technology</li>
              <li style={{ fontSize: '0.95rem', padding: '0.75rem' }}><i className="fas fa-rocket"></i> Startups</li>
              <li style={{ fontSize: '0.95rem', padding: '0.75rem' }}><i className="fas fa-shopping-cart"></i> FMCG</li>
              <li style={{ fontSize: '0.95rem', padding: '0.75rem' }}><i className="fas fa-industry"></i> Manufacturing</li>
              <li style={{ fontSize: '0.95rem', padding: '0.75rem' }}><i className="fas fa-truck"></i> Logistics</li>
              <li style={{ fontSize: '0.95rem', padding: '0.75rem' }}><i className="fas fa-tools"></i> Engineering</li>
              <li style={{ fontSize: '0.95rem', padding: '0.75rem' }}><i className="fas fa-store"></i> Retail</li>
              <li style={{ fontSize: '0.95rem', padding: '0.75rem' }}><i className="fas fa-phone"></i> Telecom</li>
              <li style={{ fontSize: '0.95rem', padding: '0.75rem' }}><i className="fas fa-hospital"></i> Healthcare</li>
              <li style={{ fontSize: '0.95rem', padding: '0.75rem' }}><i className="fas fa-bolt"></i> Energy</li>
              <li style={{ fontSize: '0.95rem', padding: '0.75rem' }}><i className="fas fa-university"></i> Financial Services</li>
            </ul>
          </div>

          <div className="service-section">
            <h2>The RPO Impact</h2>
            <p style={{ textAlign: 'center', fontSize: '1.1rem', marginBottom: '2rem' }}>Partnering with HRCONSOL empowers your business to:</p>
            <ul className="benefits-list">
              <li>
                <span className="benefit-heading">Reduce hiring time by 40%</span>
              </li>
              <li>
                <span className="benefit-heading">Cut recruitment cost per hire by up to 50%</span>
              </li>
              <li>
                <span className="benefit-heading">Improve candidate retention and engagement</span>
              </li>
              <li>
                <span className="benefit-heading">Scale hiring instantly during business growth phases</span>
              </li>
            </ul>
          </div>

          <div className="service-section">
            <h2>Our Results Speak</h2>
            <ul className="benefits-list">
              <li>
                <span className="benefit-heading">10,000+ Positions Closed</span>
                <span className="benefit-subheading">across multiple industries and regions</span>
              </li>
              <li>
                <span className="benefit-heading">100+ Satisfied Clients</span>
                <span className="benefit-subheading">across Pakistan, UAE & West Africa</span>
              </li>
              <li>
                <span className="benefit-heading">95% Retention Rate</span>
                <span className="benefit-subheading">consistent within first 12 months</span>
              </li>
            </ul>
          </div>

          <div className="service-cta">
            <h2>Ready to Transform Your Recruitment Process?</h2>
            <p>Let HRCONSOL become your trusted recruitment partner.</p>
            <button onClick={() => navigate('/#contact')} className="cta-button">Contact Us</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RPO;

